export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';

type DemoItem = {
    key: number
    role: 'ai' | 'user'
    content: string
};

interface Props {
    roles: Record<string, any>
    hasMoreHistory: boolean
    loadingHistory: boolean
    nextHistoryKey: number
    items: DemoItem[]
}

function createItem(index: number): DemoItem {
    return {
        key: index,
        role: index % 2 ? 'ai' : 'user',
        content: `历史消息 #${index}`,
    };
}

function createRoles(): Props['roles'] {
    return {
        ai: {
            placement: 'start',
            avatar: true,
            roleName: 'AI 助手',
        },
        user: {
            placement: 'end',
            avatar: true,
            roleName: '我',
            variant: 'outlined',
        },
    };
}

function createState(): Props {
    return {
        roles: createRoles(),
        hasMoreHistory: true,
        loadingHistory: false,
        nextHistoryKey: 7,
        items: [8, 9, 10, 11, 12, 13, 14].map(createItem),
    };
}

export default class extends Component<Props> {
    static template = template;

    private timer: number | null = null;

    static defaults() {
        return createState();
    }

    @bind
    loadHistory() {
        if (this.get('loadingHistory') || !this.get('hasMoreHistory')) return;

        this.set('loadingHistory', true);
        this.timer = window.setTimeout(() => {
            const nextHistoryKey = this.get('nextHistoryKey');
            const nextItems = [nextHistoryKey - 2, nextHistoryKey - 1, nextHistoryKey].map(createItem);

            this.set({
                items: nextItems.concat(this.get('items')),
                nextHistoryKey: nextHistoryKey - 3,
                hasMoreHistory: nextHistoryKey - 3 > 0,
                loadingHistory: false,
            });
        }, 600);
    }
}